import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MojoBudgetVsActualWidgetComponent } from "./containers/mojo-budget-vs-actual-widget/mojo-budget-vs-actual-widget.component";
import { MojoBudgetVsActualTableComponent } from "./components/budget-vs-actual-table/mojo-budget-vs-actual-table.component";
import { BudgetVsActualHttpService } from "./services/budget-vs-actual-http.service";
import { BudgetVsActualFacadeService } from "./services/budget-vs-actual-facade.service";
import { BudgetVsActualConfigHttpService } from "./services/budget-vs-actual-config-http.service";
import { BudgetVsActualConfigFacadeService } from "./services/budget-vs-actual-config-facade.service";
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as reducers from './reducers/budget-vs-actual.reducers';
import * as configReducers from './reducers/budget-vs-actual-config.reducers';
import { BudgetVsActualEffects } from './effects/budget-vs-actual.effects';
import { BudgetVsActualConfigEffects } from './effects/budget-vs-actual-config.effects';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SplitButtonModule } from 'primeng/splitbutton';
import { BudgetVsActualPeriodsService } from './services/budget-vs-actual-periods.service';
import {
  MojoBudgetVsActualItemComponent
} from "@feature/_app_modules/budget-vs-actual/components/budget-vs-actual-item.component/mojo-budget-vs-actual-item.component";
import {
  MojoBudgetVsActualItemTableComponent
} from "@feature/_app_modules/budget-vs-actual/components/budget-vs-actual-item-table/mojo-budget-vs-actual-item-table.component";
import { BudgetVsActualWidgetAdminHandler } from './services/budget-vs-actual-admin-handler';
import {
  MojoBudgetVsActualChartComponent
} from "@feature/_app_modules/budget-vs-actual/components/budget-vs-actual-chart/mojo-budget-vs-actual-chart.component";
import { MojoBudgetVsActualItemNoteComponent } from "@feature/_app_modules/budget-vs-actual/components/budget-vs-actual-item-note/mojo-budget-vs-actual-item-note.component";
import { PanelModule } from 'primeng/panel';
import {FormLayoutModule} from "@feature/_app_modules/form-layout/form-layout.module";
import {
  MojoBudgetVsActualEditNoteComponent
} from "@feature/_app_modules/budget-vs-actual/components/budget-vs-actual-edit-note/mojo-budget-vs-actual-edit-note";
import {
  MojoBudgetVsActualApportPercentDialogComponent
} from "@feature/_app_modules/budget-vs-actual/components/budget-vs-actual-apportionment-percentages/budget-vs-actual-apport-percent-dialog.component";
import {MojoBudgetVsActualWidgetPrintLayoutComponent} from "@feature/_app_modules/budget-vs-actual/components/print-layout/mojo-budget-vs-actual-widget-print-layout.component";
import {HideDropdownOnScrollModule} from "@feature/common";
import {
  MojoBudgetVsActualFilterDialogComponent
} from "@feature/_app_modules/budget-vs-actual/components/budget-vs-actual-filter-dialog/budget-vs-actual-filter-dialog.component";

@NgModule({
  declarations: [
    MojoBudgetVsActualTableComponent,
    MojoBudgetVsActualWidgetComponent,
    MojoBudgetVsActualItemComponent,
    MojoBudgetVsActualItemTableComponent,
    MojoBudgetVsActualChartComponent,
    MojoBudgetVsActualItemNoteComponent,
    MojoBudgetVsActualEditNoteComponent,
    MojoBudgetVsActualApportPercentDialogComponent,
    MojoBudgetVsActualWidgetPrintLayoutComponent,
    MojoBudgetVsActualFilterDialogComponent
  ],
  exports: [
    MojoBudgetVsActualWidgetComponent,
    MojoBudgetVsActualWidgetPrintLayoutComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature('budgetVsActual', reducers.reducer),
        StoreModule.forFeature('budgetVsActualConfig', configReducers.reducer),
        EffectsModule.forFeature([BudgetVsActualEffects]),
        EffectsModule.forFeature([BudgetVsActualConfigEffects]),
        FormLayoutModule,
        DropdownModule,
        CalendarModule,
        InputTextModule,
        ButtonModule,
        RippleModule,
        SplitButtonModule,
        PanelModule,
        HideDropdownOnScrollModule
    ],
  providers: [
    BudgetVsActualHttpService,
    BudgetVsActualFacadeService,
    BudgetVsActualConfigHttpService,
    BudgetVsActualConfigFacadeService,
    BudgetVsActualPeriodsService,
    BudgetVsActualWidgetAdminHandler
  ]
})
export class BudgetVsActualModule { }
